export default __webpack_public_path__ + "static/media/no-project.c4677d03.png";